import { ExternalLinkIcon, FileTextIcon } from 'lucide-react';
import type { ChatDocumentDTO } from '@shared/schemas/chat';
import { cn } from '@/lib/utils';
import type { ActiveSourceReference } from '../chat-experience';

type ChatSourceCardProps = {
  document: ChatDocumentDTO;
  sourceReference?: ActiveSourceReference | null;
  sourceReferences?: ActiveSourceReference[];
  onOpen: (
    document: ChatDocumentDTO,
    reference?: ActiveSourceReference | null,
    references?: ActiveSourceReference[] | null,
  ) => void;
};

function getSourceTitle(document: ChatDocumentDTO) {
  return document.filename ?? document.title ?? 'Source documentaire';
}

export function ChatSourceCard({
  document,
  onOpen,
  sourceReference = null,
  sourceReferences = [],
}: ChatSourceCardProps) {
  const title = getSourceTitle(document);

  return (
    <button
      type="button"
      onClick={() => onOpen(document, sourceReference, sourceReferences)}
      className={cn(
        'group flex h-12 w-full min-w-0 items-center gap-2.5 rounded-lg border border-border/70 bg-background px-3 text-left transition',
        'hover:border-border hover:bg-muted/25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40',
      )}
      aria-label={`Ouvrir le panneau ${title}`}
      data-testid={sourceReference ? 'citation-chip' : undefined}
    >
      <span className="flex size-7 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground">
        <FileTextIcon className="size-3.5" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-xs font-semibold text-foreground">{title}</span>
        {sourceReference?.page ? (
          <span className="block truncate text-[11px] text-muted-foreground">
            Page {sourceReference.page}
          </span>
        ) : null}
      </span>
      <ExternalLinkIcon className="size-3.5 shrink-0 text-muted-foreground opacity-70 transition group-hover:opacity-100" />
    </button>
  );
}
